import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {ChangeEvent, CKEditor5, CKEditorComponent} from '@ckeditor/ckeditor5-angular';
import '@ckeditor/ckeditor5-build-classic/build/translations/tr';

@Component({
    selector: 'noos-htmleditor',
    templateUrl: './htmleditor.component.html',
    styleUrls: ['./htmleditor.component.scss']
})
@NoosFormTypeService.register('htmleditor')
export class HtmleditorComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('editor', {static: true}) editorComponent: CKEditorComponent;
    mhClass = 'mh400';

    editorToolBars = {
        text: ['bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent',
            '|', 'blockQuote', 'undo', 'redo'],
        standart: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent',
            '|', 'blockQuote', 'insertTable', 'mediaEmbed', 'undo', 'redo'],
        advance: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent',
            '|', 'imageUpload', 'blockQuote', 'insertTable', 'mediaEmbed', 'undo', 'redo']
    };


    public Editor = ClassicEditor;
    public model = {
        editorData: ''
    };
    const;
    config: CKEditor5.Config = {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent',
            '|', 'blockQuote', 'insertTable', 'mediaEmbed', 'undo', 'redo'], // imageUpload
        viewportTopOffset: 10,
        placeholder: '...',
        shouldNotGroupWhenFull: true,
        language: 'tr',
    };

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }


    public onChange({editor}: ChangeEvent) {
        this.prop.defaultValue = editor.getData();
    }

    ngOnInit() {
        this.mhClass = this.prop.options.heightClass || 'mh200';
        this.config.toolbar = this.editorToolBars[this.prop.options.toolbar];
        this.config.placeholder = this.prop.placeHolderText;
    }

    ngAfterViewInit(): void {

    }
}
